// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-observation-component {
  margin-bottom: 2rem;
  /* start of observation hours css */
}
.lsn-observation-component .lsn-observation-group {
  margin-bottom: 2rem;
}
.lsn-observation-component table td {
  word-break: break-all;
}
.lsn-observation-component .lsn-observation-table {
  margin: 40px 0px 45px 0px;
}
.lsn-observation-component .lsn-observation-input {
  width: 60%;
}
.lsn-observation-component .lsn-observation-facility-padding {
  padding-top: 0px;
  padding-bottom: 0px;
}
.lsn-observation-component .lsn-observationHours-name {
  padding-top: 5px;
  padding-bottom: 5px;
}
.lsn-observation-component .lsn-observation-input-customize input {
  width: 60%;
}
.lsn-observation-component .lsn-input-errorlsn-observation-input-customize input {
  width: 60%;
}
.lsn-observation-component .lsn-observation-select-customize {
  width: 90%;
}
.lsn-observation-component .lsn-observation-radio-div {
  margin-bottom: 8px;
}
.lsn-observation-component .lsn-observation-radio-mandatory {
  margin: 0px 0px 0px 5px;
  color: var(--main-red);
}
.lsn-observation-component .lsn-observation-checkbox checkbox {
  margin-right: 10px;
}
.lsn-observation-component .lsn-obs-error-tag {
  color: var(--main-red);
  padding-left: 25px;
}
.lsn-observation-component .lsn-obs-check-not-approve {
  padding: 0 22px 10px;
}
.lsn-observation-component .lsn-obs-table {
  border: 1px solid var(--main-bg-color-lighter);
  margin-bottom: 10px;
}
.lsn-observation-component .lsn-obs-table th {
  padding: 10px;
  font-weight: normal;
}
.lsn-observation-component .lsn-obs-table thead {
  background-color: color-mix(in srgb, var(--main-bg-color-lighter) 20%, var(--main-primary-color) 30%);
}
.lsn-observation-component .lsn-obs-table-first-column {
  width: 55%;
}
.lsn-observation-component .lsn-obs-table-comp-col {
  width: 19%;
  text-align: center;
}
.lsn-observation-component .lsn-obs-table-td {
  text-align: center;
}
.lsn-observation-component .lsn-obs-table tbody tr.active,
.lsn-observation-component .table.table-striped tbody tr.active {
  background-color: var(--main-bg-color-lighter);
}
.lsn-observation-component .lsn-obs-table.table-striped tbody tr:nth-of-type(odd) {
  background-color: color-mix(in srgb, var(--main-bg-color-lighter), var(--main-primary-color) 10%);
}
.lsn-observation-component .lsn-obs-total-table {
  border: 1px solid var(--main-border-color);
  background-color: color-mix(in srgb, var(--main-bg-color-lighter), var(--main-black) 10%);
  margin-bottom: 10px;
}
.lsn-observation-component .lsn-obs-total-table-thead {
  width: 302px;
}
.lsn-observation-component .lsn-observation-check-mark {
  color: var(--main-primary-color);
  margin-left: 10px;
}
.lsn-observation-component .lsn-observation-check-mark-not {
  margin-left: 10px;
}
.lsn-observation-component .lsn-obs-patient-checklist {
  list-style-type: none;
  width: 100%;
  margin-bottom: 37px;
  margin-top: 0px;
  padding-left: 0px;
  position: relative;
  margin-left: 0px;
}
.lsn-observation-component .lsn-obs-patient-checklistLi {
  margin: 0px;
  position: relative;
  text-align: left;
  padding-left: 20px;
  margin: 6px 0px;
  display: flex;
  align-items: center;
}
.lsn-observation-component .lsn-obs-patient-checklist-test {
  left: 0;
  position: absolute;
}
`, "",{"version":3,"sources":["webpack://./src/pages/recommendationForm/ObservationHours/ObservationHours.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,mCAAmC;AACrC;AAHA;EAII,mBAAA;AAEJ;AANA;EAQI,qBAAA;AACJ;AATA;EAaI,yBAAA;AADJ;AAZA;EAiBI,UAAA;AAFJ;AAfA;EAqBI,gBAAA;EACA,mBAAA;AAHJ;AAnBA;EA0BI,gBAAA;EACA,mBAAA;AAJJ;AAvBA;EAgCM,UAAA;AANN;AA1BA;EAsCM,UAAA;AATN;AA7BA;EA2CI,UAAA;AAXJ;AAhCA;EA+CI,kBAAA;AAZJ;AAnCA;EAmDI,uBAAA;EACA,sBAAA;AAbJ;AAvCA;EAyDM,kBAAA;AAfN;AA1CA;EA8DI,sBAAA;EACA,kBAAA;AAjBJ;AA9CA;EAmEI,oBAAA;AAlBJ;AAjDA;EAuEI,8CAAA;EACA,mBAAA;AAnBJ;AArDA;EA4EI,aAAA;EACA,mBAAA;AApBJ;AAzDA;EAiFI,qGAAA;AArBJ;AA5DA;EAqFI,UAAA;AAtBJ;AA/DA;EAyFI,UAAA;EACA,kBAAA;AAvBJ;AAnEA;EA8FI,kBAAA;AAxBJ;AAtEA;;EAmGI,8CAAA;AAzBJ;AA1EA;EAuGI,iGAAA;AA1BJ;AA7EA;EA2GI,0CAAA;EACA,yFAAA;EACA,mBAAA;AA3BJ;AAlFA;EAiHI,YAAA;AA5BJ;AArFA;EAqHI,gCAAA;EACA,iBAAA;AA7BJ;AAzFA;EA0HI,iBAAA;AA9BJ;AA5FA;EA8HI,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AA/BJ;AArGA;EAwII,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAhCJ;AA9GA;EAkJI,OAAA;EACA,kBAAA;AAjCJ","sourcesContent":[".lsn-observation-component {\n  margin-bottom: 2rem;\n\n  .lsn-observation-group {\n    margin-bottom: 2rem;\n  }\n\n  table td {\n    word-break: break-all;\n  }\n\n  /* start of observation hours css */\n  .lsn-observation-table {\n    margin: 40px 0px 45px 0px;\n  }\n\n  .lsn-observation-input {\n    width: 60%;\n  }\n\n  .lsn-observation-facility-padding {\n    padding-top: 0px;\n    padding-bottom: 0px;\n  }\n\n  .lsn-observationHours-name {\n    padding-top: 5px;\n    padding-bottom: 5px;\n  }\n\n  .lsn-observation-input-customize {\n    input {\n      width: 60%;\n    }\n  }\n\n  .lsn-input-errorlsn-observation-input-customize {\n    input {\n      width: 60%;\n    }\n  }\n\n  .lsn-observation-select-customize {\n    width: 90%;\n  }\n\n  .lsn-observation-radio-div {\n    margin-bottom: 8px;\n  }\n\n  .lsn-observation-radio-mandatory {\n    margin: 0px 0px 0px 5px;\n    color: var(--main-red);\n  }\n\n  .lsn-observation-checkbox {\n    checkbox {\n      margin-right: 10px;\n    }\n  }\n\n  .lsn-obs-error-tag {\n    color: var(--main-red);\n    padding-left: 25px;\n  }\n\n  .lsn-obs-check-not-approve {\n    padding: 0 22px 10px;\n  }\n\n  .lsn-obs-table {\n    border: 1px solid var(--main-bg-color-lighter);\n    margin-bottom: 10px;\n  }\n\n  .lsn-obs-table th {\n    padding: 10px;\n    font-weight: normal;\n  }\n\n  .lsn-obs-table thead {\n    background-color: color-mix(in srgb, var(--main-bg-color-lighter) 20%, var(--main-primary-color) 30%);\n  }\n\n  .lsn-obs-table-first-column {\n    width: 55%;\n  }\n\n  .lsn-obs-table-comp-col {\n    width: 19%;\n    text-align: center;\n  }\n\n  .lsn-obs-table-td {\n    text-align: center;\n  }\n\n  .lsn-obs-table tbody tr.active,\n  .table.table-striped tbody tr.active {\n    background-color: var(--main-bg-color-lighter);\n  }\n\n  .lsn-obs-table.table-striped tbody tr:nth-of-type(odd) {\n    background-color: color-mix(in srgb, var(--main-bg-color-lighter), var(--main-primary-color) 10%);\n  }\n\n  .lsn-obs-total-table {\n    border: 1px solid var(--main-border-color);\n    background-color: color-mix(in srgb, var(--main-bg-color-lighter), var(--main-black) 10%);\n    margin-bottom: 10px;\n  }\n\n  .lsn-obs-total-table-thead {\n    width: 302px;\n  }\n\n  .lsn-observation-check-mark {\n    color: var(--main-primary-color);\n    margin-left: 10px;\n  }\n\n  .lsn-observation-check-mark-not {\n    margin-left: 10px;\n  }\n\n  .lsn-obs-patient-checklist {\n    list-style-type: none;\n    width: 100%;\n    margin-bottom: 37px;\n    margin-top: 0px;\n    padding-left: 0px;\n    position: relative;\n    margin-left: 0px;\n  }\n\n  .lsn-obs-patient-checklistLi {\n    margin: 0px;\n    position: relative;\n    text-align: left;\n    padding-left: 20px;\n    margin: 6px 0px;\n    display: flex;\n    align-items: center;\n  }\n\n  .lsn-obs-patient-checklist-test {\n    left: 0;\n    position: absolute;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
